import { render, staticRenderFns } from "./SliderEditor.vue?vue&type=template&id=37f902ac&scoped=true&"
import script from "./SliderEditor.vue?vue&type=script&lang=js&"
export * from "./SliderEditor.vue?vue&type=script&lang=js&"
import style0 from "./SliderEditor.vue?vue&type=style&index=0&id=37f902ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f902ac",
  null
  
)

export default component.exports